import { render, staticRenderFns } from "./DealInvoice.vue?vue&type=template&id=ba96c14e&scoped=true&"
import script from "./DealInvoice.vue?vue&type=script&lang=js&"
export * from "./DealInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DealInvoice.vue?vue&type=style&index=0&id=ba96c14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba96c14e",
  null
  
)

export default component.exports